export default __webpack_public_path__ + "static/media/needle.97ec6f41.svg";